import * as actionTypes from '../actions/actionTypes'

const initialState = {
  records: [],
  pagination: { total: 0, perPage: 10, currentPage: 1, lastPage: 0, from: 0, to: 0 },
  imported: false,
  bulkUpdateSuccess: false,
  saveActionToSuccess: false,
  loadingStates: [],
  filterOptions: null,
  filterAppraisalTypes: null,
  filterCompanies: null,
  filterForms: null,
  filterStructures: null,
  filterLevelGroups: null,
  filterOrgs: null,
  filterPositions: null,
  filterEmps: null,
  filterStatus: null,
  appraisalSavedList: [],

  actionToOptions: {
    positionGroupOptions: null,
    empOptions: null,
    positionOptions: null,
    orgOptions: null
  },
  assesorGroups: null,

  competencyTypes: [],
  frequencies: [],
  appraisalData: [],
  appraisalInfo: {},
  commentList: [],
  toStageList: null,
  actionPlanData: [],
  responsible: [],
  competencyScores: [],
  loadingResponsible: false,
  loadingActionPlan: false,
  gantt: []
}

const fetchAppraisalTypeOptionsStart = state => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'appraisal_type_id']
  }
}

const fetchAppraisalTypeOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'appraisal_type_id'),
    filterAppraisalTypes: data
  }
}

const fetchAppraisalTypeOptionsFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'appraisal_type_id')
  }
}

const fetchCompanyOptionsStart = state => {
  return { ...state, loadingStates: [...state.loadingStates, 'company_id'] }
}

const fetchCompanyOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'company_id'),
    filterCompanies: data
  }
}

const fetchCompanyOptionsFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'company_id')
  }
}

const fetchFormOptionsStart = state => {
  return { ...state, loadingStates: [...state.loadingStates, 'form_id'] }
}

const fetchFormOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'form_id'),
    filterForms: data
  }
}

const fetchFormOptionsFailed = state => {
  return { ...state, loadingStates: state.loadingStates.filter(item => item !== 'form_id') }
}

const fetchStructureOptionsStart = state => {
  return { ...state, loadingStates: [...state.loadingStates, 'structure_id'] }
}

const fetchStructureOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'structure_id'),
    filterStructures: data
  }
}

const fetchStructureOptionsFailed = state => {
  return { ...state, loadingStates: state.loadingStates.filter(item => item !== 'structure_id') }
}

const fetchLevelGroupOptionsStart = state => {
  return { ...state, loadingStates: [...state.loadingStates, 'level_group_id'] }
}

const fetchLevelGroupOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'level_group_id'),
    filterLevelGroups: data
  }
}

const fetchLevelGroupOptionsFailed = state => {
  return { ...state, loadingStates: state.loadingStates.filter(item => item !== 'level_group_id') }
}

const fetchOrganizationOptionsStart = state => {
  return { ...state, loadingStates: [...state.loadingStates, 'org_id'] }
}

const fetchOrganizationOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'org_id'),
    filterOrgs: data
  }
}

const fetchOrganizationOptionsFailed = state => {
  return { ...state, loadingStates: state.loadingStates.filter(item => item !== 'org_id') }
}

const fetchPositionOptionsStart = state => {
  return { ...state, loadingStates: [...state.loadingStates, 'position_id'] }
}

const fetchPositionOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'position_id'),
    filterPositions: data
  }
}

const fetchPositionOptionsFailed = state => {
  return { ...state, loadingStates: state.loadingStates.filter(item => item !== 'position_id') }
}

const fetchEmployeeOptionsStart = state => {
  return { ...state, loadingStates: [...state.loadingStates, 'emp_id'] }
}

const fetchEmployeeOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'emp_id'),
    filterEmps: data
  }
}

const fetchEmployeeOptionsFailed = state => {
  return { ...state, loadingStates: state.loadingStates.filter(item => item !== 'emp_id') }
}

const fetchStatusOptionsStart = state => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'status_id']
  }
}

const fetchStatusOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'status_id'),
    filterStatus: data
  }
}

const fetchStatusOptionsFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'status_id')
  }
}

const fetchActionToPositionGroupOptionsStart = state => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'position_group_id']
  }
}

const fetchActionToPositionGroupOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'position_group_id'),
    actionToOptions: { ...state.actionToOptions, positionGroupOptions: data }
  }
}

const fetchActionToPositionGroupOptionsFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'position_group_id')
  }
}

const fetchActionToOrganizationOptionsStart = state => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'org_id']
  }
}

const fetchActionToOrganizationOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'org_id'),
    actionToOptions: { ...state.actionToOptions, orgOptions: data }
  }
}

const fetchActionToOrganizationOptionsFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'org_id')
  }
}

const fetchActionToPositionOptionsStart = state => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'position_id']
  }
}

const fetchActionToPositionOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'position_id'),
    actionToOptions: { ...state.actionToOptions, positionOptions: data }
  }
}

const fetchActionToPositionOptionsFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'emp_id')
  }
}

const fetchActionToEmployeeOptionsStart = state => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'emp_id']
  }
}

const fetchActionToEmployeeOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'emp_id'),
    actionToOptions: { ...state.actionToOptions, empOptions: data }
  }
}

const fetchActionToEmployeeOptionsFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'emp_id')
  }
}

const fetchActionToAssessorGroupOptionsStart = state => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'assessor_group']
  }
}
const fetchActionToAssessorGroupOptionsSuccess = (state, { data }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'assessor_group'),
    assessorGroups: data
  }
}
const fetchActionToAssessorGroupOptionsFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'assessor_group')
  }
}

const fetchAppraisalsStart = state => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'records']
  }
}

const fetchAppraisalsSuccess = (state, { records, pagination }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'records'),
    filtered: true,
    records: records,
    pagination: pagination
  }
}

const fetchAppraisalsFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'records'),
    filtered: false
  }
}

const fetchAppraisalResultStart = state => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'appraisalData']
  }
}

const fetchAppraisalResultSuccess = (state, { appraisalInfo, appraisalData }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'appraisalData'),
    appraisalInfo: appraisalInfo,
    appraisalData: appraisalData.map(st => ({ ...st, stage_id: st.stage[0]?.stage_id || null })),
    appraisalSavedList: []
  }
}

const fetchAppraisalResultFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'appraisalData')
  }
}

const importAppraisalStart = state => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'import'],
    imported: false
  }
}

const importAppraisalSuccess = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'import'),
    imported: true
  }
}

const importAppraisalFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'import'),
    imported: false
  }
}

const exportAppraisalStart = state => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'export']
  }
}

const exportAppraisalSuccess = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'export')
  }
}

const exportAppraisalFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'export')
  }
}

const downloadAppraisalTemplateStart = state => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'export']
  }
}

const downloadAppraisalTemplateSuccess = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'export')
  }
}

const downloadAppraisalTemplateFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'export')
  }
}

const clearFilteredAppraisalRecords = state => {
  return {
    ...state,
    // filterOptions: null,
    records: [],
    pagination: { total: 0, perPage: 0, currentPage: 0, lastPage: 0, from: 0, to: 0 }
  }
}

const fetchCommentsStart = (state, payload) => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'loadComment']
  }
}

const fetchCommentsSuccess = (state, { comments }) => {
  return {
    ...state,
    commentList: comments,
    loadingStates: state.loadingStates.filter(item => item !== 'loadComment')
  }
}

const fetchCommentsFailed = (state, payload) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'loadComment')
  }
}

const postCommentStart = (state, payload) => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'postComment']
  }
}
const postCommentSuccess = (state, { comment }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'postComment'),
    commentList: [comment, ...state.commentList]
  }
}
const postCommentFailed = (state, payload) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'postComment'),
    commentSuccess: true
  }
}

const setAppraisalFilter = (state, { filterOptions }) => {
  return {
    ...state,
    filterOptions: filterOptions
  }
}

const clearSelectedAppraisalData = state => {
  return {
    ...state,
    appraisalData: [],
    appraisalInfo: {},
    commentList: [],
    appraisalSavedList: []
  }
}

const saveAppraisalStart = state => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'saveAppraisal']
  }
}

const saveAppraisalSuccess = (state, { structureId }) => {
  return {
    ...state,
    appraisalSavedList: [...state.appraisalSavedList, structureId],
    loadingStates: state.loadingStates.filter(item => item !== 'saveAppraisal')
  }
}

const saveAppraisalFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'saveAppraisal')
  }
}

const fetchToStageStart = state => {
  return { ...state, loadingStates: [...state.loadingStates, 'stage_id'] }
}

const fetchToStageSuccess = (state, { toStageList }) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'stage_id'),
    toStageList: toStageList
  }
}

const fetchToStageFailed = state => {
  return { ...state, loadingStates: state.loadingStates.filter(item => item !== 'stage_id') }
}

const bulkUpdateAppraisalStart = state => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'bulkUpdateAppraisal'],
    bulkUpdateSuccess: false
  }
}

const bulkUpdateAppraisalSuccess = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'bulkUpdateAppraisal'),
    bulkUpdateSuccess: true
  }
}

const bulkUpdateAppraisalFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'bulkUpdateAppraisal'),
    bulkUpdateSuccess: false
  }
}

const saveActionToStart = state => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'saveActionTo'],
    saveActionToSuccess: false
  }
}

const saveActionToSuccess = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'saveActionTo'),
    saveActionToSuccess: true
  }
}

const saveActionToFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'saveActionTo'),
    saveActionToSuccess: false
  }
}

const fetchActionPlanStart = state => {
  return {
    ...state,
    loadingActionPlan: true
  }
}

const fetchActionPlanSuccess = (state, action) => {
  let [data] = action.data.data
  return {
    ...state,
    actionPlanData: data,
    loadingActionPlan: false
  }
}

const fetchActionPlanFailed = state => {
  return {
    ...state,
    loadingActionPlan: false
  }
}

const fetchResponsibleOptions = (state, action) => {
  // let [data] = action.data.data
  return {
    ...state,
    responsible: action.data,
    loadingResponsible: false
  }
}

const fetchResponsibleOptionsStart = (state, action) => {
  return {
    ...state,
    loadingResponsible: true
  }
}

const fetchResponsibleOptionsFailed = (state, action) => {
  return {
    ...state,
    loadingResponsible: false
  }
}

const setGantt = (state, action) => {
  return {
    ...state,
    gantt: action
  }
}

const sumUpStart = state => {
  return {
    ...state,
    loadingStates: [...state.loadingStates, 'records']
  }
}

const sumUpSuccess = (state, {data}) => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'records')
  }
}

const sumUpFailed = state => {
  return {
    ...state,
    loadingStates: state.loadingStates.filter(item => item !== 'records')
  }
}

export default (state = initialState, { type, ...payload }) => {
  switch (type) {
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FOR_APPRAISAL_START:
      return fetchAppraisalTypeOptionsStart(state, payload)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchAppraisalTypeOptionsSuccess(state, payload)
    case actionTypes.FETCH_APPRAISAL_TYPE_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchAppraisalTypeOptionsFailed(state, payload)

    case actionTypes.FETCH_TO_STAGE_START:
      return fetchToStageStart(state, payload)
    case actionTypes.FETCH_TO_STAGE_SUCCESS:
      return fetchToStageSuccess(state, payload)
    case actionTypes.FETCH_TO_STAGE_FAILED:
      return fetchToStageFailed(state, payload)

    case actionTypes.BULK_UPDATE_APPRAISAL_START:
      return bulkUpdateAppraisalStart(state, payload)
    case actionTypes.BULK_UPDATE_APPRAISAL_SUCCESS:
      return bulkUpdateAppraisalSuccess(state, payload)
    case actionTypes.BULK_UPDATE_APPRAISAL_FAILED:
      return bulkUpdateAppraisalFailed(state, payload)

    case actionTypes.FETCH_APPRAISAL_RESULT_START:
      return fetchAppraisalResultStart(state, payload)
    case actionTypes.FETCH_APPRAISAL_RESULT_SUCCESS:
      return fetchAppraisalResultSuccess(state, payload)
    case actionTypes.FETCH_APPRAISAL_RESULT_FAILED:
      return fetchAppraisalResultFailed(state, payload)

    case actionTypes.APPRAISAL_SAVE_START:
      return saveAppraisalStart(state, payload)
    case actionTypes.APPRAISAL_SAVE_SUCCESS:
      return saveAppraisalSuccess(state, payload)
    case actionTypes.APPRAISAL_SAVE_FAILED:
      return saveAppraisalFailed(state, payload)

    case actionTypes.FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_START:
      return fetchCompanyOptionsStart(state, payload)
    case actionTypes.FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchCompanyOptionsSuccess(state, payload)
    case actionTypes.FETCH_COMPANY_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchCompanyOptionsFailed(state, payload)

    case actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_START:
      return fetchFormOptionsStart(state, payload)
    case actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchFormOptionsSuccess(state, payload)
    case actionTypes.FETCH_FORM_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchFormOptionsFailed(state, payload)

    case actionTypes.FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_START:
      return fetchStructureOptionsStart(state, payload)
    case actionTypes.FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchStructureOptionsSuccess(state, payload)
    case actionTypes.FETCH_STRUCTURE_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchStructureOptionsFailed(state, payload)

    case actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_START:
      return fetchLevelGroupOptionsStart(state, payload)
    case actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchLevelGroupOptionsSuccess(state, payload)
    case actionTypes.FETCH_LEVEL_GROUP_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchLevelGroupOptionsFailed(state, payload)

    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_START:
      return fetchOrganizationOptionsStart(state, payload)
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchOrganizationOptionsSuccess(state, payload)
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchOrganizationOptionsFailed(state, payload)

    case actionTypes.FETCH_POSITION_OPTIONS_FOR_APPRAISAL_START:
      return fetchPositionOptionsStart(state, payload)
    case actionTypes.FETCH_POSITION_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchPositionOptionsSuccess(state, payload)
    case actionTypes.FETCH_POSITION_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchPositionOptionsFailed(state, payload)

    case actionTypes.FETCH_EMPLOYEE_OPTIONS_FOR_APPRAISAL_START:
      return fetchEmployeeOptionsStart(state, payload)
    case actionTypes.FETCH_EMPLOYEE_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchEmployeeOptionsSuccess(state, payload)
    case actionTypes.FETCH_EMPLOYEE_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchEmployeeOptionsFailed(state, payload)

    case actionTypes.FETCH_APPRAISAL_STATUS_OPTIONS_FOR_APPRAISAL_START:
      return fetchStatusOptionsStart(state, payload)
    case actionTypes.FETCH_APPRAISAL_STATUS_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchStatusOptionsSuccess(state, payload)
    case actionTypes.FETCH_APPRAISAL_STATUS_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchStatusOptionsFailed(state, payload)

    case actionTypes.FETCH_POSITION_GROUP_OPTIONS_START:
      return fetchActionToPositionGroupOptionsStart(state, payload)
    case actionTypes.FETCH_POSITION_GROUP_OPTIONS_SUCCESS:
      return fetchActionToPositionGroupOptionsSuccess(state, payload)
    case actionTypes.FETCH_POSITION_GROUP_OPTIONS_FAILED:
      return fetchActionToPositionGroupOptionsFailed(state, payload)

    case actionTypes.FETCH_ORGANIZATION_OPTIONS_START:
      return fetchActionToOrganizationOptionsStart(state, payload)
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_SUCCESS:
      return fetchActionToOrganizationOptionsSuccess(state, payload)
    case actionTypes.FETCH_ORGANIZATION_OPTIONS_FAILED:
      return fetchActionToOrganizationOptionsFailed(state, payload)

    case actionTypes.FETCH_POSITION_OPTIONS_START:
      return fetchActionToPositionOptionsStart(state, payload)
    case actionTypes.FETCH_POSITION_OPTIONS_SUCCESS:
      return fetchActionToPositionOptionsSuccess(state, payload)
    case actionTypes.FETCH_POSITION_OPTIONS_FAILED:
      return fetchActionToPositionOptionsFailed(state, payload)

    case actionTypes.FETCH_EMPLOYEE_OPTIONS_START:
      return fetchActionToEmployeeOptionsStart(state, payload)
    case actionTypes.FETCH_EMPLOYEE_OPTIONS_SUCCESS:
      return fetchActionToEmployeeOptionsSuccess(state, payload)
    case actionTypes.FETCH_EMPLOYEE_OPTIONS_FAILED:
      return fetchActionToEmployeeOptionsFailed(state, payload)

    case actionTypes.FETCH_ASSESSOR_GROUP_OPTIONS_START:
      return fetchActionToAssessorGroupOptionsStart(state, payload)
    case actionTypes.FETCH_ASSESSOR_GROUP_OPTIONS_SUCCESS:
      return fetchActionToAssessorGroupOptionsSuccess(state, payload)
    case actionTypes.FETCH_ASSESSOR_GROUP_OPTIONS_FAILED:
      return fetchActionToAssessorGroupOptionsFailed(state, payload)

    case actionTypes.SAVE_ACTION_TO_START:
      return saveActionToStart(state, payload)
    case actionTypes.SAVE_ACTION_TO_SUCCESS:
      return saveActionToSuccess(state, payload)
    case actionTypes.SAVE_ACTION_TO_FAILED:
      return saveActionToFailed(state, payload)

    case actionTypes.FETCH_APPRAISAL_DATA_START:
      return fetchAppraisalsStart(state, payload)
    case actionTypes.FETCH_APPRAISAL_DATA_SUCCESS:
      return fetchAppraisalsSuccess(state, payload)
    case actionTypes.FETCH_APPRAISAL_DATA_FAILED:
      return fetchAppraisalsFailed(state, payload)

    case actionTypes.FETCH_APPRAISAL_COMMENT_START:
      return fetchCommentsStart(state, payload)
    case actionTypes.FETCH_APPRAISAL_COMMENT_SUCCESS:
      return fetchCommentsSuccess(state, payload)
    case actionTypes.FETCH_APPRAISAL_COMMENT_FAILED:
      return fetchCommentsFailed(state, payload)

    case actionTypes.POST_APPRAISAL_COMMENT_START:
      return postCommentStart(state, payload)
    case actionTypes.POST_APPRAISAL_COMMENT_SUCCESS:
      return postCommentSuccess(state, payload)
    case actionTypes.POST_APPRAISAL_COMMENT_FAILED:
      return postCommentFailed(state, payload)

    case actionTypes.IMPORT_APPRAISAL_START:
      return importAppraisalStart(state, payload)
    case actionTypes.IMPORT_APPRAISAL_SUCCESS:
      return importAppraisalSuccess(state, payload)
    case actionTypes.IMPORT_APPRAISAL_FAILED:
      return importAppraisalFailed(state, payload)

    case actionTypes.EXPORT_APPRAISAL_START:
      return exportAppraisalStart(state, payload)
    case actionTypes.EXPORT_APPRAISAL_SUCCESS:
      return exportAppraisalSuccess(state, payload)
    case actionTypes.EXPORT_APPRAISAL_FAILED:
      return exportAppraisalFailed(state, payload)

    case actionTypes.DOWNLOAD_APPRAISAL_TEMPLATE_START:
      return downloadAppraisalTemplateStart(state, payload)
    case actionTypes.DOWNLOAD_APPRAISAL_TEMPLATE_SUCCESS:
      return downloadAppraisalTemplateSuccess(state, payload)
    case actionTypes.DOWNLOAD_APPRAISAL_TEMPLATE_FAILED:
      return downloadAppraisalTemplateFailed(state, payload)

    case actionTypes.SET_APPRAISAL_FILTER:
      return setAppraisalFilter(state, payload)

    case actionTypes.CLEAR_FILTERED_APPRAISAL_RECORDS:
      return clearFilteredAppraisalRecords(state, payload)

    case actionTypes.CLEAR_SELECTED_APPRAISAL_DATA:
      return clearSelectedAppraisalData(state, payload)

    case actionTypes.FETCH_ACTION_PLAN_START:
      return fetchActionPlanStart(state, payload)
    case actionTypes.FETCH_ACTION_PLAN_SUCCESS:
      return fetchActionPlanSuccess(state, payload)
    case actionTypes.FETCH_ACTION_PLAN_FAILED:
      return fetchActionPlanFailed(state, payload)

    case actionTypes.FETCH_RESPONSIBLE_OPTIONS_FOR_APPRAISAL_START:
      return fetchResponsibleOptionsStart(state, payload)
    case actionTypes.FETCH_RESPONSIBLE_OPTIONS_FOR_APPRAISAL_SUCCESS:
      return fetchResponsibleOptions(state, payload)
    case actionTypes.FETCH_RESPONSIBLE_OPTIONS_FOR_APPRAISAL_FAILED:
      return fetchResponsibleOptionsFailed(state, payload)

    case actionTypes.APPRAISAL_SET_GANTT_CHART:
      return setGantt(state, payload)

    case actionTypes.APPRAISAL_SUM_UP_START:
      return sumUpStart(state, payload)
    case actionTypes.APPRAISAL_SUM_UP_SUCCESS:
      return sumUpSuccess(state, payload)
    case actionTypes.APPRAISAL_SUM_UP_FAILED:
      return sumUpFailed(state, payload)

    case actionTypes.SIGNOUT_SUCCESS:
    case actionTypes.SIGNOUT_FAILED:
      return { ...initialState }
    default:
      return state
  }
}
